import axios from '../../axios'
/*
 * 文件上传
 */

// 保存
export const fileUpload = (type,data) => {
  return axios({
    url: '/file/imageup/'+type,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/file/file.js